import { render, staticRenderFns } from "./DamTable.vue?vue&type=template&id=c85c303c&scoped=true"
import script from "./DamTable.vue?vue&type=script&lang=ts"
export * from "./DamTable.vue?vue&type=script&lang=ts"
import style0 from "./DamTable.vue?vue&type=style&index=0&id=c85c303c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85c303c",
  null
  
)

export default component.exports